// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__136aX","inputWrap":"Table_inputWrap__221bp","col":"Table_col__3W75N","bmiTooltip":"Table_bmiTooltip__3a0zC"};